<template>
  <div class="assetReport">
    <div class="intro-y box p-5 mt-5">
      <div class="personnels-title">资产报表统计</div>
        <el-form :form="form">
          <el-form-item label="资产产权证地址:">
            <el-input v-model='form.certificateAddress' placeholder="请输入资产产权证地址" style="width:230px;margin-right: 50px"/>
            <el-button type="primary" style="margin-right:10px;" @click="seek" :loading="loading">
              搜寻
            </el-button>
            <el-button type="primary" @click="showModal">
              报表导出
            </el-button>
          </el-form-item>
        </el-form>

    </div>
    <div class="personnels-main">
      <div class="asset-page-content">
        <div style="overflow: hidden">
          <div style="width: 300px;height: 100px;float: left">
            <div class="intro-y col-span-12 mt-5">
              <table class="table table-report -mt-2">
                <thead>
                <tr>
                  <th class="whitespace-no-wrap">资产产权证地址</th>
                  <th class="whitespace-no-wrap">管理单位名称</th>
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="(item, index) in modele"
                        :key="index"
                        class="intro-x"
                >
                  <td style="width: 200px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.certificateAddress
                      }}</div>
                  </td>
                  <td style="width: 200px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.managementEnterprise
                      }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="flex: 1">
            <div class="intro-y col-span-12 overflow-auto mt-5">
              <table class="table table-report -mt-2">
                <thead>
                <tr>
                  <th class="whitespace-no-wrap">资产来源</th>
                  <th class="whitespace-no-wrap">资产编号</th>
                  <th class="whitespace-no-wrap">资产出租地址明细</th>
                  <th class="whitespace-no-wrap">房屋建筑面积</th>
                  <th class="whitespace-no-wrap">房屋建筑物账面价值</th>
                  <th class="whitespace-no-wrap">房屋建筑物净值</th>
                  <th class="whitespace-no-wrap">土地面积</th>
                  <th class="whitespace-no-wrap">土地账面价</th>
                  <th class="whitespace-no-wrap">有无房地产权证</th>
                  <th class="whitespace-no-wrap">老版房屋证号或新版房地产权证号</th>
                  <th class="whitespace-no-wrap">资产所在区</th>
                  <th class="whitespace-no-wrap">街镇名称</th>
                  <th class="whitespace-no-wrap">资产实际所有人与产权证登记权利人是否一致</th>
                  <th class="whitespace-no-wrap">资产实际所有人</th>
                  <th class="whitespace-no-wrap">产权证登记权利人</th>
                  <th class="whitespace-no-wrap">产证原件保管单位</th>
                  <th class="whitespace-no-wrap">产证土地用途</th>
                  <th class="whitespace-no-wrap">实际用途</th>
                  <th class="whitespace-no-wrap">土地使用权来源</th>
                  <th class="whitespace-no-wrap">它项权利限制情况</th>
                  <th class="whitespace-no-wrap">定价方式</th>
                  <th class="whitespace-no-wrap">是否为直管公房</th>
                  <th class="whitespace-no-wrap">资产备注</th>
                  <th class="whitespace-no-wrap">资产出租地址明细</th>
                  <th class="whitespace-no-wrap">房屋建筑面积(m²)</th>
                  <th class="whitespace-no-wrap">招租方式</th>
                  <th class="whitespace-no-wrap">承租人或使用人</th>
                  <th class="whitespace-no-wrap">租客类型</th>
                  <th class="whitespace-no-wrap">承租人或使用人是否改制企业</th>
                  <th class="whitespace-no-wrap">合同起始日期</th>
                  <th class="whitespace-no-wrap">合同结束日期</th>
                  <th class="whitespace-no-wrap">租赁期限（月）</th>
                  <th class="whitespace-no-wrap">租金收取间隔</th>
                  <th class="whitespace-no-wrap">房屋当前使用状态</th>
                  <th class="whitespace-no-wrap">土地当前使用状态</th>
                  <th class="whitespace-no-wrap">是否转租</th>
                  <th class="whitespace-no-wrap">押金(元)</th>
                  <th class="whitespace-no-wrap">当期合同年租金（元）</th>
                  <th class="whitespace-no-wrap">租金单价（元）</th>
                  <th class="whitespace-no-wrap">应收租金</th>
                  <th class="whitespace-no-wrap">历史已收缴租金</th>
                  <th class="whitespace-no-wrap">欠收租金</th>
                  <th class="whitespace-no-wrap">租金收至日期</th>
                  <th class="whitespace-no-wrap">存在免租期</th>
                  <th class="whitespace-no-wrap">备注</th>
                </tr>
                </thead>
                <tbody>
                <tr
                        v-for="(item, index) in modele"
                        :key="index"
                        class="intro-x"
                >
                  <td style="width: 120px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.assetSource
                      }}</div>
                  </td>
                  <td style="width: 120px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.certificateNumber
                      }}</div>
                  </td>
                  <td style="width: 160px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.assetBuildingArea
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.assetAddressDetail
                      }}</div>
                  </td>
                  <td style="width: 170px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.buildingBookValue
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.buildingNetWorth
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.landBookValue
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.hasEstateCertificate ? '有' :'无'
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.oldLandCertificateNumber
                      }}</div>
                  </td>
                  <td style="width: 250px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.estateCertificateNumber
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.assetAddressDesc
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.assetStreet
                      }}</div>
                  </td>
                  <td style="width: 185px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.isActualOwner? '一致' :'不一致'
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.assetActualOwner
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.certificateOwner
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.certificateCustodian
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.landUseFor
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.actualUseFor
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.useRightSource
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.restriction
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.pricingMethod
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.isStraightBuilding? '是' :'否'
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.remark
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.remark
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.contractBuildingArea
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.rentingMethod
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.lessee
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.tenantType
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.reformedEnterprise
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.contractStartDate
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.contractEndDate
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.leaseTerm
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.rentCollectionInterval
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.houseUseStatus
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.landUseStatus
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.whetherSublease
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.deposit
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.annualContractRent
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.dailyRentalUnitPrice
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.totalAmountReceivable
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.historyReceived
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.arrears
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.rentCollectionDate
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.rentFreePeriod
                      }}</div>
                  </td>
                  <td style="width: 150px">
                    <div class="font-medium whitespace-no-wrap">{{
                      item.contractRemark
                      }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div
            class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5"
    >
      <el-pagination
              layout="prev, pager, next"
              :background='false'
              :page-size="pagination.perPage"
              :current-page="pagination.page"
              @current-change="handleTableChange"
              :total="pagination.total">
      </el-pagination>
      <select class="w-20 input box mt-3 sm:mt-0" @change='onShowSizeChange' v-model='pagination.perPage'>
        <option :value='10'>10</option>
        <option :value='25'>25</option>
        <option :value='35'>35</option>
        <option :value='50'>50</option>
      </select>
    </div>
    <el-dialog
      title="新增模板"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :before-close="handleCancel"
      :footer="null"
      width="1000px"
    >
      <div class="add-model">
        <div class="model-left" style="border-right: 1px solid #e8e8e8;padding-top: 10px;padding-right: 10px">
          <div style="padding-bottom: 8px">待选择列</div>
          <div style="padding-bottom: 10px">
            <el-button type="primary" @click="addAsset">
              添加
            </el-button>
          </div>
          <div>
            <!--<el-table-->
              <!--:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"-->
              <!--:columns="columns2"-->
              <!--:data-source="data"-->
              <!--:loading="loading2"-->
              <!--:pagination="false"-->
              <!--:scroll="{y: 350 }"-->
            <!--/>-->
            <el-table
                ref="multipleTable"
                :data="data"
                tooltip-effect="dark"
                style="width: 100%"
                height="350"
                @selection-change="onSelectChange">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column
                prop="name"
                label="列名">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="model-right" style="padding-top: 10px">
          <div style="padding-bottom: 8px">已选择列</div>
          <div style="display: flex;vertical-align: center;align-items: center;padding-bottom: 10px">
            <div>标题 <span style="color: red">*</span>：</div>
            <el-input style="width: 300px" v-model='addTitle' placeholder="请输入标题"/>
            <el-button type="primary" style="margin-left: 10px" @click="submitBtn()" :loading="loading3">
              确认导出excel
            </el-button>
          </div>
          <div style="padding-bottom: 12px;padding-top: 10px">
            <el-button type="primary" style="margin-right: 10px" @click="deleteSelect">
              删除选定
            </el-button>
            <el-button type="primary" @click="deleteAll">
              删除全部
            </el-button>
          </div>
          <div>
            <el-table
                    ref="multipleTable"
                    :data="data2"
                    tooltip-effect="dark"
                    style="width: 100%"
                    height="300"
                    @selection-change="onSelectChange2">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column
                      prop="name"
                      label="列名">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getAssetAllFieldList,getAssetOptionalField,exportAssetOptional} from "../../api/organization";
  import {downFile} from '../../assets/js/tools'
  export default {
    name: "assetReport",
    components: {},
    data() {
      return {
        data:[],
        data2:[],
        original: [],
        columns2:[
          {
            title: '列名',
            dataIndex: 'name',
          },
        ],
        selectedRowKeys: [], // Check here to configure the default column
        selectedRowKeys2: [],
        addTitle: '',
        visible: false,
        confirmLoading: false,
        form:{
          certificateAddress:'',
        },
        pagination: {
          page: 1,
          total: 0,
          perPage: 10,
        },
        loading:false,
        loading2:false,
        loading3: false,
        modele:[

        ],
      }
    },
    methods: {
      onShowSizeChange(e){
        this.pagination.page = 1;
        this.getList();
      },
      onSelectChange(val) {
        this.selectedRowKeys = val;
      },
      onSelectChange2(val) {
        this.selectedRowKeys2 = val;
      },
      handleCancel(e) {
        this.visible = false;
        this.data = this.original;
        if(!this.original){
          this.getAssetOptionalField();
        }
        this.data2 = [];
        this.selectedRowKeys = [];
        this.selectedRowKeys2 = [];
      },
      showModal() {
        this.visible = true;
      },
      handleChange(nextTargetKeys, direction, moveKeys) {
        this.targetKeys = nextTargetKeys;
      },
      handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
      },
      handleChange2(nextTargetKeys, direction, moveKeys) {
        this.targetKeys2 = nextTargetKeys;
      },
      handleSelectChange2(sourceSelectedKeys, targetSelectedKeys) {
        this.selectedKeys2 = [...sourceSelectedKeys, ...targetSelectedKeys];
      },
      //查找
      seek(){
        this.pagination.current = 1;
        this.getList();
      },
      //拉取列表
      getList(){
        let para = this.form;
        para.page = this.pagination.page;
        para.perPage = this.pagination.perPage;
        this.loading = true;
        getAssetAllFieldList(para).then(res => {
          this.loading = false
          let data = res.data
          if (data.code === '000') {
            this.modele = data.content.assetAllFieldList.list;
            this.pagination.total = data.content.assetAllFieldList.total;
          } else {

          }
        }).catch(err => {
          this.loading = false
          console.log(err);
        }).finally(() => {
          this.loading = false
        })
      },
      getAssetOptionalField(){
        this.loading2 = true;
        getAssetOptionalField().then(res => {
          this.loading2 = false;
          let data = res.data;
          if (data.code === '000') {
            this.data = data.content.assetOptionalField;
            this.original = data.content.assetOptionalField;
          } else {

          }
        }).catch(err => {
          this.loading2 = false
          console.log(err);
        }).finally(() => {
          this.loading2 = false
        })
      },
      handleTableChange(page) {
        this.pagination.page = page;
        this.getList();
      },
      sourceChange(val){
        console.log(val)
      },
      //新增
      addAsset(){
        if(this.selectedRowKeys.length<=0){
          this.$message.error("请选择新增项目");
          return
        }
        console.log(this.selectedRowKeys);
        let data = [];
        for(let i=0;i<this.selectedRowKeys.length;i++){
          data.push(this.selectedRowKeys[i]);
        }
        for(let i=0;i<data.length;i++){
          this.data2.push(data[i]);
        }
        let Difference = this.original.filter(item=>!this.data2.includes(item));
        this.data = Difference;
        this.selectedRowKeys = [];
        this.selectedRowKeys2 = [];
      },
      //删除全部
      deleteAll(){
        this.data = this.original;
        this.data2 = [];
        this.selectedRowKeys = [];
        this.selectedRowKeys2 = [];
      },
      //删除
      deleteSelect(){
        if(this.selectedRowKeys2.length<=0){
          this.$message.error("请选择删除项目");
          return
        }
        let data = [];
        for(let i=0;i<this.selectedRowKeys2.length;i++){
          data.push(this.selectedRowKeys2[i]);
        }
        let Difference = this.data2.filter(item=>!data.includes(item));
        this.data2 = Difference;
        let Difference2 = this.original.filter(item=>!this.data2.includes(item));
        this.data = Difference2;
        this.selectedRowKeys = [];
        this.selectedRowKeys2 = [];
      },
      submitBtn(){
        if(!this.addTitle){
          this.$message.error("请输入标题");
          return
        }
        if(this.data2.length<=0){
          this.$message.error("请添加导出项目");
          return
        }
        this.loading3 = true;
        let data = [];
        for(let i=0;i<this.data2.length;i++){
          data.push(this.data2[i].id);
        }
        let para = {
          fileName: this.addTitle,
          fieldId: data,
          certificateAddress: this.form.certificateAddress,
        };
        exportAssetOptional(para).then(res => {
          this.loading3 = false;
          if (res) {
            downFile(res,this.addTitle);
            this.$message.success('导出成功');
            this.handleCancel();
          } else {
            this.$message.error('失败');
          }
        }).finally(() => {
          this.loading3 = false
        })
      }
    },
    created() {
      this.getList();
      this.getAssetOptionalField();
    },
  }
</script>
<style>
  .assetReport .el-dialog__body{
    padding: 0 20px 30px;
  }
</style>
<style scoped lang="scss">

    .personnels-title{
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 20px;
    }

  .search-form{
    padding-bottom: 5px;
  }
  .add-l{
    width: 200px;
    .add-title{
      background-color: #e9f7fe;
      line-height: 46px;
      padding-left: 25px;
      font-size: 14px;
      border-right: 3px solid #4390f7;
      color: #4390f7;
    }
  }
  .add-r{
    flex: 1;
    padding-left: 25px;
    border-left: 1px solid rgba(235, 235, 235, 1);
  }
  .title-frame{
    background-color: #fff;
    padding: 25px 25px 15px;
    .personnels-title{
      font-size: 20px;
      line-height: 28px;
      font-weight: bold;
      padding-bottom: 20px;
    }
  }

  .add-model{
    display: flex;
    .model-left{
      width: 420px;
    }
    .model-right{
      flex: 1;
      padding-left: 10px;
    }
  }
</style>
